/* Imperial Pawnbrokers v6: reveals, floating header, nav pill, service tabs, live hours. No dependencies. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  root.classList.add('js');
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }

  // Stagger siblings inside each grid.
  each('.bento, .faq6', function (g) {
    Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i % 6); });
  });

  // Reveal on scroll.
  var items = document.querySelectorAll('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  // Floating header tightens after scrolling.
  var header = document.querySelector('[data-header]');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Nav: gold pill follows hover and the section in view.
  var nav = document.querySelector('[data-nav]');
  if (nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
    var active = null;
    var pillTo = function (a) {
      links.forEach(function (l) { l.classList.toggle('is-lit', l === a); });
      if (!a) { nav.style.setProperty('--po', '0'); return; }
      nav.style.setProperty('--px', a.offsetLeft + 'px');
      nav.style.setProperty('--pw', a.offsetWidth + 'px');
      nav.style.setProperty('--po', '1');
    };
    nav.classList.add('is-ready');
    links.forEach(function (a) {
      a.addEventListener('mouseenter', function () { pillTo(a); });
      a.addEventListener('focus', function () { pillTo(a); });
    });
    nav.addEventListener('mouseleave', function () { pillTo(active); });
    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          active = links.filter(function (a) { return a.getAttribute('data-spy') === e.target.id; })[0] || null;
          if (!nav.matches(':hover')) pillTo(active);
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      each('main section', function (s) { spy.observe(s); });
    }
  }

  // Mobile menu.
  var btn = document.querySelector('[data-menu-btn]');
  var menu = document.querySelector('[data-menu]');
  if (btn && menu) {
    var set = function (open) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); menu.hidden = !open; };
    btn.addEventListener('click', function () { set(menu.hidden); });
    Array.prototype.forEach.call(menu.querySelectorAll('a'), function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  // Service tabs (WAI-ARIA tabs: click, arrow keys, Home/End).
  each('[data-tabs]', function (wrap) {
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
    var seg = wrap.querySelector('.seg');
    var select = function (i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
      seg.style.setProperty('--tab', i);
      if (focus) tabs[i].focus();
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, k = e.key, to = null;
        if (k === 'ArrowRight') to = (i + 1) % n;
        else if (k === 'ArrowLeft') to = (i - 1 + n) % n;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = n - 1;
        if (to !== null) { e.preventDefault(); select(to, true); }
      });
    });
  });

  // Live open/closed status in the shop's time zone.
  var es = document.documentElement.lang === 'es';
  var statuses = document.querySelectorAll('[data-open-now]');
  if (statuses.length && window.Intl) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
      var day = '', hour = 0;
      parts.forEach(function (p) { if (p.type === 'weekday') day = p.value; if (p.type === 'hour') hour = parseInt(p.value, 10) % 24; });
      var open = day !== 'Sun' && hour >= 10 && hour < 17;
      statuses.forEach(function (status) {
        status.textContent = es ? (open ? 'Abierto ahora' : 'Cerrado ahora') : (open ? 'Open now' : 'Closed now');
        status.classList.toggle('is-open', open);
      });
    } catch (e) {}
  }

  // Hero tile: soft gold light follows the pointer.
  var spot = document.querySelector('[data-spot]');
  if (spot && fine && !reduce) {
    spot.addEventListener('pointermove', function (e) {
      var r = spot.getBoundingClientRect();
      spot.style.setProperty('--sx', (e.clientX - r.left) + 'px');
      spot.style.setProperty('--sy', (e.clientY - r.top) + 'px');
    });
  }


  // Reviews carousel: arrows, counter, and auto-advance (2s on phones, one review; 7s on desktop, one batch).
  // Pauses on hover, touch, keyboard focus, when off screen or the tab is hidden, and when the owner of
  // the device asked for reduced motion. A pause/play button stops it for good (WCAG 2.2.2).
  each('[data-carousel]', function (car) {
    var track = car.querySelector('[data-track]');
    var slides = track.children, n = slides.length;
    var prev = car.querySelector('[data-prev]'), next = car.querySelector('[data-next]');
    var toggle = car.querySelector('[data-toggle]');
    var count = car.querySelector('[data-pos]');
    var gap = function () { return parseFloat(getComputedStyle(track).columnGap) || 0; };
    var step = function () { return slides[0].getBoundingClientRect().width + gap(); };
    var perView = function () { return Math.max(1, Math.round((track.clientWidth + gap()) / step())); };
    var atEnd = function () { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; };
    var sync = function () {
      var s = step(), idx = Math.round(track.scrollLeft / s), per = perView();
      count.textContent = per === 1 ? (idx + 1) + ' of ' + n : (idx + 1) + '–' + Math.min(idx + per, n) + ' of ' + n;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = atEnd();
    };
    var go = function (dir, amount) { track.scrollBy({ left: dir * amount * step(), behavior: reduce ? 'auto' : 'smooth' }); };
    prev.addEventListener('click', function () { go(-1, 1); });
    next.addEventListener('click', function () { go(1, 1); });
    var ticking = false;
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; sync(); }); } }, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    // Auto-advance.
    var userPaused = reduce, hovering = false, focused = false, visible = false, timer = null;
    var setToggle = function () {
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', userPaused ? 'Play auto-scrolling' : 'Pause auto-scrolling');
    };
    var schedule = function () {
      clearTimeout(timer);
      if (userPaused || hovering || focused || !visible || document.hidden) return;
      var per = perView();
      timer = setTimeout(function () {
        if (atEnd()) track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
        else go(1, per);
        schedule();
      }, per === 1 ? 2000 : 7000);
    };
    toggle.addEventListener('click', function () { userPaused = !userPaused; setToggle(); schedule(); });
    car.addEventListener('mouseenter', function () { hovering = true; schedule(); });
    car.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    car.addEventListener('focusin', function () { focused = true; schedule(); });
    car.addEventListener('focusout', function () { focused = car.contains(document.activeElement); schedule(); });
    track.addEventListener('touchstart', function () { hovering = true; schedule(); }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { hovering = false; schedule(); }, 4000); }, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; schedule(); }, { threshold: 0.4 }).observe(car);
    } else { visible = true; }
    setToggle();
    schedule();
  });

  // Yelp's review widget script loads only when the reviews come near the screen, so it does not slow the first view.
  var yelpSpot = document.querySelector('.yelp-review');
  if (yelpSpot) {
    var yelpLoaded = false;
    var loadYelp = function () {
      if (yelpLoaded) return;
      yelpLoaded = true;
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.yelp.com/embed/widgets.js';
      document.body.appendChild(s);
    };
    if ('IntersectionObserver' in window) {
      var yio = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { yio.disconnect(); loadYelp(); }
      }, { rootMargin: '1200px 0px' });
      yio.observe(yelpSpot.closest('section') || yelpSpot);
    } else { loadYelp(); }
  }

  // Count-up for [data-count] numbers (the hero's years in business), once, when seen.
  each('[data-count]', function (el) {
    var to = parseInt(el.getAttribute('data-count'), 10);
    if (!to || reduce) return;
    var run = function () {
      var start = null;
      el.textContent = '0';
      requestAnimationFrame(function stepFn(t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / 1800);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(stepFn);
      });
    };
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { seen.disconnect(); setTimeout(run, 350); } }, { threshold: 0.6 });
      seen.observe(el);
    } else { run(); }
  });

  // Hero (from v5, calmer): rotating word every 3.2s, light gold dust, soft spotlight.
  var rot = document.querySelector('[data-rotator]');
  if (rot && !reduce) {
    var words = rot.children, wi = 0;
    setInterval(function () {
      if (document.hidden) return;
      var cur = words[wi];
      wi = (wi + 1) % words.length;
      cur.classList.remove('is-active'); cur.classList.add('is-out');
      words[wi].classList.remove('is-out'); words[wi].classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-out'); }, 700);
    }, 3200);
  }
  var hero = document.querySelector('[data-hero]');
  if (hero && fine && !reduce) {
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      hero.style.setProperty('--sx', (e.clientX - r.left) + 'px');
      hero.style.setProperty('--sy', (e.clientY - r.top) + 'px');
    });
  }
  var canvas = document.querySelector('[data-dust]');
  if (canvas && canvas.getContext && !reduce) {
    var ctx = canvas.getContext('2d'), dots = [], running = false, cw = 0, ch = 0;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var size = function () {
      cw = canvas.clientWidth; ch = canvas.clientHeight;
      canvas.width = cw * dpr; canvas.height = ch * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      dots = [];
      for (var i = 0, n = Math.round(Math.min(36, cw / 32)); i < n; i++) {
        dots.push({ x: Math.random() * cw, y: Math.random() * ch, r: Math.random() * 1.3 + 0.4, v: Math.random() * 0.12 + 0.04, t: Math.random() * 6.28 });
      }
    };
    var draw = function () {
      if (!running) return;
      ctx.clearRect(0, 0, cw, ch);
      dots.forEach(function (p) {
        p.y -= p.v; p.t += 0.012;
        if (p.y < -4) { p.y = ch + 4; p.x = Math.random() * cw; }
        ctx.beginPath();
        ctx.fillStyle = 'rgba(236, 208, 122,' + (0.2 + 0.3 * (0.5 + 0.5 * Math.sin(p.t))).toFixed(3) + ')';
        ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fill();
      });
      requestAnimationFrame(draw);
    };
    size();
    window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var vis = en[0].isIntersecting;
        if (vis && !running) { running = true; requestAnimationFrame(draw); }
        if (!vis) running = false;
      }).observe(canvas);
    }
  }
})();
